import {AuthConfig} from 'angular-oauth2-oidc';
import {environment} from '../../../environments/environment';

/**
 * This method ensures that a redirect_uri containing the search part of a URL (request parameters) can successfully be used
 * for token retrieval. Otherwise the token endpoint will complain as the state, session_state and code response parameters
 * are added to the redirect_uri after the initial login. This leads to an error from Keycloak. But this is probably not correctly
 * handled by the JS library we are using.
 */
let getSearchParams = function () {
  let currentOAuthRedirectUrl: URL = new URL(window.location.origin + window.location.search);
  currentOAuthRedirectUrl.searchParams.delete('state');
  currentOAuthRedirectUrl.searchParams.delete('session_state');
  currentOAuthRedirectUrl.searchParams.delete('code');
  if (!currentOAuthRedirectUrl.searchParams.has('callback')) {
    currentOAuthRedirectUrl.searchParams.append('callback', 'true');
  }
  return currentOAuthRedirectUrl.toString();
};

export const authConfig: AuthConfig = {
  issuer: environment.oidcAuthority,
  redirectUri: getSearchParams(),
  clientId: environment.oidcClientId,
  dummyClientSecret: 'secret',
  scope: 'openid profile email offline_access',
  responseType: 'code',
  timeoutFactor: 0.75,
  useSilentRefresh: false, // Needed for Code Flow to suggest using iframe-based refreshes
  sessionChecksEnabled: false,
  showDebugInformation: true, // Also requires enabling "Verbose" level in devtools
  clearHashAfterLogin: false, // https://github.com/manfredsteyer/angular-oauth2-oidc/issues/457#issuecomment-431807040
};

